export function TracingContactsTableHeader({ showPatientColumn }: { showPatientColumn: boolean }) {
  return (
    <>
      <th style={{ width: 180, minWidth: 180 }}>Name</th>
      <th style={{ width: 160, minWidth: 160 }}>Vorname</th>
      <th style={{ width: 125 }}>Geb.</th>
      {showPatientColumn && <th style={{ width: 130, minWidth: 130 }}>TB-Fall</th>}
      <th style={{ width: 150 }}>Inkubationszeit aktivieren</th>
      <th style={{ width: 140 }}>TB Anamnese</th>
      <th style={{ width: 130 }}>Termin/e</th>
      <th style={{ width: 130 }}>Test erfolgt</th>
      <th style={{ width: 60 }}>Mx</th>
      <th style={{ width: 60 }}>QFT</th>
      <th style={{ width: 75 }}>T-Spot</th>
      <th style={{ width: 85 }}>Rx</th>
      <th style={{ width: 60 }}>S</th>
      <th style={{ width: 100 }}>TBI</th>
      <th style={{ width: 85 }}>Status</th>
    </>
  );
}
